module.exports = __webpack_public_path__ + "rainy_icon.png";